module.exports = __webpack_public_path__ + "static/media/lct.1f2087b3.png";